<template>
  <div class="treeSpliter" align="left">
    <div id="nodeButtonDiv">
      <div class="buttonMargin"><a-button type="primary" class="button-color-green" @click="addNode">增</a-button></div>
      <div class="buttonMargin"><a-button type="primary" class="button-color-purple" @click="editNode">改</a-button></div>
      <div class="buttonMargin"><a-button type="primary" class="button-color-cyan" @click="doexpain">展</a-button></div>
      <div class="buttonMargin"><a-button type="primary" class="button-color-sunset" @click="unexpain">收</a-button></div>
      <div class="buttonMargin"><a-button type="primary" @click="reloadMenuTree">刷</a-button></div>
      <div class="buttonMargin-right"><a-button type="danger" @click="removeNode">删</a-button></div>
      <div style="clear: both"></div>
    </div>
    <div id="nodeTreeDiv" style="border-top:1px solid #f1f1f1">
      <a-input-search style="margin-bottom: 8px" placeholder="Search" v-model="searchValue" @change="onSearchTextChange" />
      <a-tree
        :expanded-keys="expandedKeys"
        :auto-expand-parent="autoExpandParent"
        :tree-data="treeData"
        @expand="onExpand"
        @select="onSelect"
      >
        <template slot="title" slot-scope="{ title }">
        <span v-if="title.indexOf(searchValue) > -1">
          {{ title.substr(0, title.indexOf(searchValue)) }}<span style="color:orangered;font-weight:bold">{{ searchValue }}</span>{{ title.substr(title.indexOf(searchValue) + searchValue.length) }}
        </span>
          <span v-else>{{ title }}</span>
        </template>
      </a-tree>
    </div>
    <a-modal v-model="nodeTreeModalVisible" title="调整节点" @ok="saveNodeInfo">
      <div>
        <div style="margin-bottom: 16px">
          <a-input addon-before="节点名：" v-model="nodeName" />
        </div>
        <div style="margin-bottom: 16px">
          <a-input addon-before="顺序：" v-model="nodeSeq" />
        </div>
        <div style="margin-bottom: 16px">
          <a-input addon-before="备注：" v-model="nodeRemark" />
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import axios from "axios";
  import Vue from "vue";

  export default {
    data() {
      return {
        token:(Vue.prototype.$global.SERVER_TOKEN==null||""==Vue.prototype.$global.SERVER_TOKEN)?this.$route.query.token:Vue.prototype.$global.SERVER_TOKEN,
        allCanExpandedKeys: [],
        allItemsList: [],
        expandedKeys: ['-1'],
        autoExpandParent: false,
        searchValue:'',
        treeData:[{ title: 'ROOT', key: '-1' }],
        selectedKeys:"",
        nodeTreeModalVisible:false,
        nodeNew:true,
        nodeName:"",
        nodeSeq:"",
        nodeRemark:""
      };
    },
    mounted() {
      this.treeResize();
      this.reloadMenuTree();
    },
    created () {
      Vue.prototype.$bus.$on('fillNodeNameToTreeSearch', this.fillNodeNameToTreeSearchByTop)
    },
    beforeDestroy() {
      this.$off('fillNodeNameToTreeSearch', this.fillNodeNameToTreeSearchByTop)
    },
    methods: {
      doexpain(){this.expandedKeys = this.allCanExpandedKeys;},
      unexpain(){this.expandedKeys = ['-1'];},
      fillNodeNameToTreeSearchByTop(nodeName){
        this.searchValue = nodeName.split("____")[1];
        this.onSearchTextChange()
        this.onSelect(nodeName.split("____")[0],null)
      },
      addNode(){
        if(this.selectedKeys == 0){alert("需要先选中一个节点");return;}
        this.nodeNew=true; this.nodeName=""; this.nodeSeq="Default_Sequence"; this.nodeRemark="";
        this.nodeTreeModalVisible = true;
      },
      editNode(){
        if(this.selectedKeys == 0){alert("需要先选中一个节点");return;}
        // 读取节点信息
        this.nodeNew=false;
        this.nodeName="LOADING..."; this.nodeSeq="Default_Sequence"; this.nodeRemark="";
        this.nodeTreeModalVisible = true;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/menu/detail', {
          "id":this.selectedKeys[0]
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.nodeName = dt.menu.node_name;
            this.nodeSeq = dt.menu.node_seq;
            this.nodeRemark = dt.menu.remark;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      removeNode(){
        if(this.selectedKeys.length == 0 || this.selectedKeys[0]=='-1'){
          alert("需要先选中一个节点");
          return;
        }
        let cfm = window.confirm("删除后将无法回复，并同时删掉子节点，确认删除？");
        if(!cfm) return;
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/menu/remove', {
          "id":this.selectedKeys[0]
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.treeResize();
            this.reloadMenuTree();
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      saveNodeInfo(){
        axios.post(Vue.prototype.$global.SERVER_URL+'/wiki/menu/change', {
          "id":this.selectedKeys[0],
          "nodeNew":this.nodeNew,
          "node_name":this.nodeName,
          "node_seq":this.nodeSeq,
          "remark":this.nodeRemark
        },{headers:{token:this.token}}).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.treeResize();
            this.reloadMenuTree();
            this.nodeTreeModalVisible=false;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      reloadMenuTree(){
        let currentExpandKeys = this.expandedKeys; // 记住当前已经展开的节点
        this.treeData = [{title:'ROOT', key: '-1'}];
        this.searchValue = '';
        axios.post(
          Vue.prototype.$global.SERVER_URL+'/wiki/menu/list',
          {"pub_or_pri":2},
          {headers:{token:this.token}}
        ).then((response) => {
          let dt = response.data;
          if(dt.success){
            this.treeData = [{title:'ROOT', key: '-1', children:this.addScopedSlots(dt.data)}];
            let epk = dt.expandedKeys;
            let epi = dt.allItemsList;
            epk.push("-1");
            epi.push({title:"ROOT", key:"-1"});
            this.allCanExpandedKeys = epk;
            this.allItemsList = epi;
            this.expandedKeys = currentExpandKeys;
          }else{
            alert(dt.message);
          }
        }).catch(function (error) {
          alert(error);
        });
      },
      addScopedSlots(items){
        let subItems = [];
        for(let i=0; i<items.length; i++){
          let item = items[i];
          let newItem = {
            key:item.key,
            title:item.title,
            scopedSlots: { title: 'title' }
          }
          if(item.children && item.children.length > 0){
            newItem.children = this.addScopedSlots(item.children);
          }
          subItems.push(newItem);
        }
        return subItems;
      },
      getParentNodes(item, canExpandNodes){ // 将父节点压栈
        let canExpandNodesTemp = [];
        for(let i=0; i<canExpandNodes.length; i++) canExpandNodesTemp.push(canExpandNodes[i]);
        if(item['parent']!=null && item['parent'].length>0 && item['parent']!='null'){
          canExpandNodesTemp.push(item['parent']);
          for(let i=0; i<this.allItemsList.length; i++){
            if(item['parent'] == this.allItemsList[i].key){
              return this.getParentNodes(this.allItemsList[i], canExpandNodesTemp);
            }
          }
        }else{
          return canExpandNodesTemp;
        }
      },
      onSearchTextChange(e) {
        let value = "";

        if(e == null) {
          value = this.searchValue;
        } else {
          value = e.target.value;
        }

        if(value == ''){
          this.expandedKeys=["-1"];
          this.searchValue=value;
          return;
        }
        let canExpandNodesTemp = ['-1'];
        for(let i=0; i<this.allItemsList.length; i++){
          let item = this.allItemsList[i];
          if(item.title.indexOf(value) != -1){
            canExpandNodesTemp = this.getParentNodes(item, canExpandNodesTemp);
          }
        }
        // 将关键字变色
        this.expandedKeys=canExpandNodesTemp;
        this.searchValue=value;
      },
      onExpand(expandedKeys) {
        this.treeResize();
        this.expandedKeys = expandedKeys;
        this.autoExpandParent = false;
      },
      onSelect(selectedKeys, info) {
        this.treeResize();
        this.selectedKeys = selectedKeys;
        // 展开选中的节点
        if(selectedKeys.length > 0){
          let expandTemp = this.expandedKeys;
          expandTemp.push(selectedKeys[0])
          this.expandedKeys = expandTemp;
        }
        // 变更大框内容
        this.$emit("nodeIdChange", this.selectedKeys);
      },
      treeResize(){
        let h = document.documentElement.clientHeight-document.getElementById("nodeButtonDiv").clientHeight-61;//可见区域高度
        const ntd = document.getElementById('nodeTreeDiv');
        ntd.style.height = h+"px";
        ntd.style.overflow = "auto";
      }
      /* 当数据量特别多时，要动态加载Tree的子节点，需要在 a-tree 上添加属性：  :load-data="onLoadData"
      onLoadData(treeNode) {
        return new Promise(resolve => {
          if (treeNode.dataRef.children) { //本来就有子节点的就不重复拉取了
            resolve();
            return;
          }
          // 动态读取子节点
          axios.post(
            Vue.prototype.$global.SERVER_URL+'/wiki/menu/list',
            {"pub_or_pri":2},
            {headers:{token:this.token}}
          ).then((response) => {
            let dt = response.data;
            if(dt.success){
              treeNode.dataRef.children = dt.data;
              this.treeData = [...this.treeData];
              resolve();
            }else{
              alert(dt.message);
            }
          }).catch(function (error) {
            alert(error);
          });
        });
      }
       */
    }
  };
</script>

<style>
  .treeSpliter{
    border-right:1px solid gray
  }
  .buttonMargin{
    float:left;
    margin:5px;
  }
  .buttonMargin-right{
    float:right;
    margin:5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/personal/NodeTree.vue